// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { ReactNode } from 'react'

import type { VoltraBaseProps } from '../baseProps'

export type MaskProps = VoltraBaseProps & {
  /** Voltra element used as the mask - alpha channel determines visibility */
  maskElement: ReactNode
}
